<template>
  <div class="sync-app-tile">
    <img src="@/assets/logos/Sync_app.png" alt=""/>
    <div class="info">
      <h5>Tree Crossing Sync</h5>
      <div class="tagline">
        Easily upload your family tree with all your photos and documents.
      </div>
    </div>
    <a v-if="!loadingRef && appUrlRef" :href="appUrlRef" class="btn btn-primary get-btn">
      Get for {{ osInfoRef?.name }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
.sync-app-tile {
  max-width: 400px;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr auto;
  column-gap: 0.75rem;
  row-gap: 0.5rem;

  @media (min-width: 768px) {
    max-width: 450px;
    column-gap: 1.25rem;
  }

  img {
    grid-row: 1 / span 2;
    height: 100%;
    width: auto;
    max-height: 140px;
    object-fit: contain;
  }
}

.info {
  display: flex;
  flex-direction: column;
  gap: 4px;

  h5 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: normal;

    @media (min-width: 768px) {
      font-size: 1.4rem;
    }
  }

  .tagline {
    font-size: 0.75rem;
    color: #888;

    @media (min-width: 768px) {
      font-size: 0.875rem;
    }
  }
}

.get-btn {
  min-width: 170px;
  min-height: 42px;
  justify-self: start;
}
</style>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { currentOS, osInfos } from '@/rd/ResearchDataModel'
import { getSyncAppInfoAsync, SyncAppInfo } from './SyncAppInfo'

const loadingRef = ref(false)
const syncAppInfoRef = ref<SyncAppInfo>()

const osInfoRef = computed(() => osInfos.find(os => os.id == currentOS))
const appUrlRef = computed(() => {
  if (currentOS == 'windows') {
    return syncAppInfoRef.value?.storeUrls.windows
  }
  if (currentOS == 'mac') {
    return syncAppInfoRef.value?.downloadUrls.mac
  }
  return undefined
})

onMounted(async () => {
  loadingRef.value = true
  try {
    syncAppInfoRef.value = await getSyncAppInfoAsync()
  }
  finally {
    loadingRef.value = false
  }
})
</script>
